// getters
const  restaurantProductsCategories = state => state.restaurantProductsCategories

export default {
    restaurantProductsCategories
}



// WEBPACK FOOTER //
// ./src/store/modules/restaurant/products/categories/getters.js